import { Component, OnInit } from '@angular/core';
import { Labels } from 'src/app/constants/labels';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { isBlank, isData, isPresent } from 'src/app/utils/utils';
import { RoutePath } from 'src/app/constants/routerPath';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { KEYS } from 'src/app/constants/keys';
import { CommonService } from 'src/app/services/common-service/common.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module'; 

@Component({
  selector: 'app-og-adminlogin',
  templateUrl: './og-adminlogin.component.html',
  styleUrls: ['./og-adminlogin.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, 
      SharedModule,
      ReactiveFormsModule,
      ]
})
export class OgAdminloginComponent implements OnInit {

  labelName = Labels.labels;
  labelButtons = Labels.buttons;
  labelMessages = Labels.messages;
  routePath = RoutePath;
  loginForm: FormGroup | any;
  credData: any;
  typeLogin: any;
  labelLogin = Labels.loginPage;
  ipAddress: any = '';
  customerLanguage: any = [];
  hide: boolean = true;
  messageLabel = Labels.messages;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService, private commonService: CommonService) {
    this.createLoginForm();
  }

  ngOnInit(): void {
    sessionStorage.setItem(KEYS.user_type, 'true');
    this.getIPAddress();
  }
  getIPAddress() {
    this.commonService.getMachineIPAddress().subscribe((data: any) => {
      this.ipAddress = data['ip'];
    });
  }
  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    })
  }
  onSubmit() {
    this.commonService.ogLog('this.loginForm : ', this.loginForm.value);
    if (this.loginForm.valid) {
      this.commonService.ogLog('Login Form validated : ', this.loginForm.value);
      this.authService.signInAuthenticate(this.loginForm.value.email, this.loginForm.value.password, true, false, this.ipAddress).subscribe((data: any) => {
        this.commonService.ogLog('data : ', data);
        if (isData(data)) {
          this.authService.updateUserInfo(data['table'][0], true);
          try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
          let isCredData = isPresent(JSON.parse(sessionStorage.getItem(KEYS.user_credential)!));
          let typelogin = isPresent(JSON.parse(sessionStorage.getItem(KEYS.user_type)!));
          if (isCredData) {
            this.credData = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
          }
          if (typelogin) {
            this.typeLogin = JSON.parse(sessionStorage.getItem(KEYS.user_type)!);
          }
          this.commonService.ogLog("credData:", this.credData);
          if (this.credData.user_Type == 1) {
            this.commonService.setAdminSelectedTopMenu('Customers');
            const path = RoutePath.customer;
            this.router.navigate(['/dashboard','customer']);
          }
          else if (this.credData.user_Type == 3 && this.typeLogin == true) {
            this.commonService.setAdminSelectedTopMenu(' ');
            let customerLanguage = data['table'][0].gstibo_language;
            this.commonService.ogLog("customerLanguage:", customerLanguage);
            this.loadLanguage();
            sessionStorage.setItem(KEYS.customerLanguage, JSON.stringify(customerLanguage));
            this.router.navigate([this.routePath.dashboard]);
          }
          else {
            let customerLanguage = data['table'][0].gstibo_language;
            this.commonService.ogLog("customerLanguage:", customerLanguage);
            this.loadLanguage();
            sessionStorage.setItem(KEYS.customerLanguage, JSON.stringify(customerLanguage));
            this.router.navigate([this.routePath.dashboard]);
          }

        } else {
          console.log('Login failed');
          //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
           this.commonService.showModalValidate(this.labelMessages.login_failed.message,'',this.messageLabel.static_messages.error,this.labelMessages.login_failed.title);
        }
      });

    } else {
      if (isBlank(this.loginForm.value.email)) {
        //this.toastr.warning(this.labelMessages.login_input.email);
         this.commonService.showModalValidate(this.labelMessages.login_input.email,'',this.messageLabel.static_messages.warning,this.labelMessages.login_input.email);
      } else {
       // this.toastr.warning(this.labelMessages.login_input.password);
        this.commonService.showModalValidate(this.labelMessages.login_input.password,'',this.messageLabel.static_messages.warning,this.labelMessages.login_input.password);
      }
    }
  }
  loadLanguage() {

    this.commonService.loadLanguages().subscribe((data: any) => {
      // console.log('data : ', data['table']);
      if (data['table'].length > 0) {
        this.customerLanguage = [];
        data['table'].forEach((element: any) => {
          this.customerLanguage.push({
            'id': element.gstibo_ln_code,
            'name': element.gstibo_ln_name
          });
        });
        sessionStorage.setItem(KEYS.dbLanguages, JSON.stringify(this.customerLanguage));
        // console.log('this.customerLanguage:', this.customerLanguage);
        this.commonService.loadLanguageEmitter.emit(this.customerLanguage);
      }
    });
  }

}
